import { __assign, __rest } from "tslib";
import 'focus-visible';
import React, { createContext, useContext, } from 'react';
import { createGenerateClassName, MuiThemeProvider, StylesProvider, } from '@material-ui/core/styles';
import { useResultRef } from '../hooks';
import { getWebKit154Theme, GlobalFixWebKitStyle, isWebKit154, } from '../isWebKit154';
import { ThemeProvider as StyledThemeProvider, useTheme, } from '../styled-components';
import createTheme from './createTheme';
var NestedThemeContext = createContext(false);
/**
 * sub theme provider,
 * that will use when you want use multiple theme in one app
 * that will user parent's theme when not set theme
 */
var SubThemeProvider = function (_a) {
    var themeProp = _a.theme, children = _a.children, fixWebKit154 = _a.fixWebKit154;
    var _b, _c;
    var parentTheme = useTheme();
    var isHaveParentRcTheme = (_c = (_b = parentTheme.palette) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.brand;
    // TODO: can be remove after safari fix that bug, maybe after v16
    var theme = getWebKit154Theme(!themeProp && isHaveParentRcTheme ? parentTheme : createTheme(themeProp), fixWebKit154);
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(StyledThemeProvider, { theme: theme },
            React.createElement(React.Fragment, null,
                (fixWebKit154 !== null && fixWebKit154 !== void 0 ? fixWebKit154 : isWebKit154) && React.createElement(GlobalFixWebKitStyle, null),
                children))));
};
/**
 * theme wrapper, apply in root,
 * each app should always have one `RootThemeProvider` at root,
 * if you need multiple, use `SubThemeProvider` inside that `RootThemeProvider`
 */
var RootThemeProvider = function (props) {
    var prefixGlobalClass = props.prefixGlobalClass, rest = __rest(props, ["prefixGlobalClass"]);
    // cannot pass `generateClassName: undefine`
    // otherwise global class will be random
    var stylesProviderProps = useResultRef(function () {
        return prefixGlobalClass
            ? {
                generateClassName: createGenerateClassName({
                    seed: prefixGlobalClass,
                }),
            }
            : {};
    });
    return (React.createElement(StylesProvider, __assign({ injectFirst: true }, stylesProviderProps.current),
        React.createElement(SubThemeProvider, __assign({}, rest))));
};
/**
 * theme wrapper, each app should always have one `RcThemeProvider` at root
 *
 * if you need multiple theme,
 * you can apply another `RcThemeProvider` inside root `RcThemeProvider`.
 *
 * `RcThemeProvider` can unlimited nest
 */
export var RcThemeProvider = function (props) {
    var isSubProvider = useContext(NestedThemeContext);
    var ThemeProvider = isSubProvider ? SubThemeProvider : RootThemeProvider;
    return (React.createElement(NestedThemeContext.Provider, { value: true },
        React.createElement(ThemeProvider, __assign({}, props))));
};
